"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledTheme = exports.colors = void 0;

var _device = require("./device");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var colors = {
  colors: {
    main: '#fe593b',
    main400: '#ffe0db',
    red100: '#d62728',
    aqua100: '#7DDEBD',
    orange100: '#bf452f',
    orange300: '#ffa54e',
    mustard100: '#ffc107',
    mustard200: '#F6C244',
    lemon100: '#f9f905',
    blue100: '#2d5185',
    blue200: '#3BA4FE',
    blue300: '#c3f1f5',
    blue500: '#F1F2F3',
    bluelight100: '#f3f6fa',
    green50: '#006400',
    green100: '#288403',
    green200: '#309c30',
    green300: '#7bc15f',
    green400: '#66c2AD',
    grey100: '#777',
    grey300: '#C9C9C9',
    grey500: '#dddddd',
    grey600: '#eeeeee',
    grey700: '#f7f7f7',
    black: '#000000',
    black100: '#333',
    white: '#fff',
    transparent: 'transparent'
  }
};
exports.colors = colors;
var shadows = {
  shadows: {
    menu: '0px 2px 11px 0px rgba(0,0,0,0.25)',
    alert: '0px 2px 8px 1px rgba(0,0,0,0.16)',
    button: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    buttonHover: '0px 2px 10px 0px rgba(0, 0, 0, 0.2), 0px 4px 4px 0px rgba(0, 0, 0, 0.14), 0px 6px 2px -4px rgba(0, 0, 0, 0.12)',
    card: '0 4px 8px 0 rgba(0,0,0,0.2)',
    cardHover: '0 8px 16px 0 rgba(0,0,0,.2)'
  }
};
var typography = {
  typography: {
    titleH1: {
      fontSize: '36px',
      fontWeight: '400',
      textTransform: 'capitalize'
    },
    titleH2: {
      fontSize: '20px',
      fontWeight: '800',
      textTransform: 'capitalize'
    },
    titleH3: {
      fontSize: '18px',
      fontWeight: '700',
      textTransform: 'capitalize'
    },
    titleH4: {
      fontSize: '16px',
      fontWeight: '300',
      textTransform: 'capitalize'
    },
    titleH5: {
      fontSize: '14px',
      fontWeight: '600',
      textTransform: 'capitalize'
    },
    titleH6: {
      fontSize: '12px',
      fontWeight: '100',
      textTransform: 'capitalize'
    },
    actionTitle: {
      fontSize: '16px',
      fontWeight: '600',
      textTransform: 'uppercase'
    },
    strapLine: {
      fontSize: '12px',
      fontWeight: '300'
    },
    paragraph: {
      fontSize: '13px',
      fontWeight: '300'
    },
    paragraph2: {
      fontSize: '0.929rem',
      fontWeight: '400',
      fontColor: colors.colors.grey100,
      margin: '0rem 0rem 0.714rem 0rem'
    },
    paragraph3: {
      fontSize: '0.857rem',
      fontWeight: '400',
      fontColor: colors.colors.grey100
    },
    paragraphLight: {
      fontSize: '14px',
      fontWeight: '200'
    },
    errorParagraph: {
      fontSize: '11px',
      fontWeight: '300'
    },
    cardTitle: {
      fontSize: '18px',
      fontWeight: '400',
      textTransform: 'capitalize'
    },
    cardStrapLine: {
      fontSize: '13px',
      fontWeight: '400'
    },
    infoText: {
      fontSize: '14px',
      fontWeight: '600'
    }
  }
};
var layout = {
  layout: {
    boxSize: 'auto',
    padding: '0'
  }
};
var devices = {
  devices: {
    small: _device.device.mobile,
    medium: _device.device.midSize,
    normal: _device.device.tablet,
    large: _device.device.desktop
  }
};
var buttons = {
  buttons: {
    fontSize: {
      xSmall: '10px',
      small: '13px',
      medium: '14px',
      large: '20px'
    },
    backgroundColor: {
      'default': colors.colors.main,
      'info': colors.colors.blue100,
      'warning': colors.colors.mustard100,
      'error': colors.colors.red100,
      'success': colors.colors.green100,
      'successAqua': colors.colors.aqua100,
      'disabled': colors.colors.grey500,
      'light': colors.colors.transparent,
      'light-hover': colors.colors.main400,
      'black': colors.colors.black,
      'white': colors.colors.white
    },
    color: {
      'default': colors.colors.white,
      'info': colors.colors.white,
      'warning': colors.colors.white,
      'error': colors.colors.white,
      'success': colors.colors.white,
      'successAqua': colors.colors.white,
      'disabled': colors.colors.grey100,
      'light': colors.colors.main,
      'black': colors.colors.white,
      'white': colors.colors.main
    }
  }
};

var styledTheme = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, colors), shadows), typography), layout), devices), buttons);

exports.styledTheme = styledTheme;